import { Injectable, EventEmitter } from "@angular/core";
import { tap } from "rxjs/operators";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from "@angular/common/http";
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class authInterceptor implements HttpInterceptor {
    constructor(private router: Router,
        private locationService: Location,private toastrService:ToastrService) { }
    heyStopRightThere: EventEmitter<boolean> = new EventEmitter();
    //function which will be called for all http calls
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('token');
        let updatedRequest=request
        if (token) {
          updatedRequest = request.clone({
              headers: request.headers.set("Authorization", "Bearer " + token)
          });
        }
        return next.handle(updatedRequest).pipe(
            tap(
                event => {
                    //logging the http response to browser's console in case of a success
                    if (event instanceof HttpResponse) {
                        // console.log("api call success :", event);
                    }
                },
                error => {
                    if (error.status == 403) {
                        this.router.navigate(['/token-expire']);
                        // this.heyStopRightThere.emit();
                        // this.router.navigate(['/login', { callback: location.href }]);
                        // this.locationService.back();
                    }
                    else if (error.status == 401 && error.error=="SESSION_EXPIRED") {
                        localStorage.clear();
                        this.router.navigate(['/login']);
                        this.toastrService.info("Your session has expired.Please login again")
                        // this.heyStopRightThere.emit();
                        // this.router.navigate(['/login', { callback: location.href }]);
                        // this.locationService.back();
                    }
                    else if(error.status == 401){
                      localStorage.clear();
                      this.router.navigate(['/login']);
                      this.toastrService.info("Unauthorized.Please login again")
                    }

                    //logging the http response to browser's console in case of a failuer
                    if (event instanceof HttpResponse) {
                        console.log("api call error :", event);
                    }
                }
            )
        );
        // }



    }
}
